<div class="unsubscribe-container">
  <div class="unsubscribe-card">
    <div class="card-header">
      <h2>Quant IP</h2>
    </div>

    <div class="card-body">
      <!-- Loading state -->
      <div *ngIf="loading" class="text-center py-4">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Processing...</span>
        </div>
        <p class="mt-3 text-muted">Processing your request...</p>
      </div>

      <!-- Error state -->
      <div *ngIf="!loading && error">
        <div class="text-center">
          <i class="bi bi-x-circle text-danger" style="font-size: 48px;"></i>
          <h4 class="mt-3">Unable to Unsubscribe</h4>
          <p class="text-muted">
            {{ message }}
          </p>
          <p class="text-muted">
            Please contact support if you continue to have issues.
          </p>
        </div>
      </div>

      <!-- Success state -->
      <div *ngIf="!loading && success">
        <div class="text-center">
          <i class="bi bi-check-circle text-success" style="font-size: 48px;"></i>
          <h4 class="mt-3">Successfully Unsubscribed</h4>
          <p class="text-muted">
            {{ message }}
          </p>
        </div>

        <!-- Re-engagement section -->
        <div class="re-engagement-section mt-4">
          <div class="divider">
            <span>Before you go...</span>
          </div>

          <div class="try-sia-box mt-3">
            <h5>Would you like to try SIA with our latest features?</h5>
            <p class="text-muted">
              We've been working on exciting new capabilities. Schedule a quick call to see what's new.
            </p>
            <button class="btn btn-primary request-access-btn w-100" (click)="openCalendly()">
              Request Access
            </button>
          </div>
        </div>

        <!-- Re-enable option -->
        <div class="mt-4 text-center">
          <p class="text-muted small">
            Changed your mind?
            <a routerLink="/login" class="text-decoration-none">Log in</a>
            to re-enable notifications.
          </p>
        </div>
      </div>

      <hr class="my-4">

      <div class="text-center">
        <a routerLink="/login" class="text-decoration-none">
          <i class="bi bi-arrow-left me-1"></i>
          Back to Login
        </a>
      </div>
    </div>
  </div>
</div>
